import { render } from "./Medal.vue?vue&type=template&id=6686cdea&scoped=true"
import script from "./Medal.vue?vue&type=script&lang=js"
export * from "./Medal.vue?vue&type=script&lang=js"

import "./Medal.vue?vue&type=style&index=0&id=6686cdea&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6686cdea"]])

export default __exports__